import React from 'react';
import classNames from 'classnames';
import { resolveId } from '@wix/communities-blog-client-common';
import { type LayoutConfigListComponentProps } from './layout-config-component-props';
import styles from './post-list.scss';

const PostListSimple: React.FC<LayoutConfigListComponentProps> = (props) => {
  const { ItemComponent } = props;
  const classNameForType = styles[props.type];

  return (
    <div className={classNameForType} data-hook="post-list">
      <div className={classNames(styles.list, classNameForType)}>
        {props.posts.map((post) => (
          <div key={resolveId(post)} data-id={resolveId(post)} className={styles.listItemContainer}>
            <div className={styles.listItem}>
              <ItemComponent post={post} type={props.type} itemConfig={props.itemConfig} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostListSimple;
